<div
  *ngIf="!role && role !== roleEnum.POOL && initialized"
  class="invitee-logo-wrapper">
  <img
    class="login-logo"
    src="assets/static/inpool__white.svg"
    alt="InPool Logo" />
</div>
<div
  class="support-wrapper"
  [class.not-logged-in]="!role && role !== roleEnum.POOL && initialized">
  <h1>{{ "support" | i18n }}</h1>
  <ng-container *ngIf="role || role === roleEnum.POOL">
    <p>
      {{ "supportText" | i18n }}
    </p>
    <p *ngIf="role === roleEnum.DISPO">
      <b> {{ "workDays" | i18n }}</b
      ><br />
      8:00 - 12:00 / 13:00 - 17:00
    </p>

    <p>
      <ng-container *ngIf="role === roleEnum.DISPO"
        >{{ "phone" | i18n }}:<a href="tel:+41525512222">+41 52 551 22 22</a
        ><br
      /></ng-container>
      {{ "email" | i18n }}:
      <a href="mailto:support@intemp.ch">support@intemp.ch</a>
    </p>
    <br
  /></ng-container>
  <h1 *ngIf="role || role === roleEnum.POOL">
    {{ "instructions" | i18n }}
  </h1>
  <ng-container
    *ngIf="(customers | async)?.[0]?._id == '5mT4bvAq8Qfp7Ctpm'; else default">
    <p>
      {{ "downloadGuideText" | i18n }}
      <a href="/assets/static/inpool_Anleitung_universaljob_Pool.pdf">{{
        "download" | i18n
      }}</a>
    </p>
  </ng-container>
  <ng-template #default>
    <ng-container *ngIf="role == roleEnum.POOL">
      <p>
        {{ "downloadGuideTextInformal" | i18n }}
        <br />
        <a
          href="/assets/static/inpool_anleitung_fuer_poolmitarbeitende_DE.pdf"
          >{{ "german" | i18n }}</a
        ><br />
        <a
          href="/assets/static/inpool_anleitung_fuer_poolmitarbeitende_FR.pdf"
          >{{ "french" | i18n }}</a
        >
      </p>

      <p>
        {{ "supportTextPooler" | i18n }}
      </p>
      <p>
        {{ "deleteProfileText" | i18n }}
      </p>
      <p>
        {{ "email" | i18n }}:
        <a href="mailto:support@intemp.ch">support@intemp.ch</a>
      </p>
    </ng-container>
    <ng-container *ngIf="role == roleEnum.DISPO">
      <p>
        {{ "downloadGuideTextFormal" | i18n }}
        <br />
        <a href="/assets/static/inpool_anleitung_fuer_disponenten_DE.pdf">{{
          "german" | i18n
        }}</a>
        <br />
        <a href="/assets/static/inpool_anleitung_fuer_disponenten_FR.pdf">{{
          "french" | i18n
        }}</a>
      </p>
      <p>
        {{ "downloadGuideTextForPooler" | i18n }}
        <br />
        <a
          href="/assets/static/inpool_anleitung_fuer_poolmitarbeitende_DE.pdf"
          >{{ "german" | i18n }}</a
        >
        <br />
        <a
          href="/assets/static/inpool_anleitung_fuer_poolmitarbeitende_FR.pdf"
          >{{ "french" | i18n }}</a
        >
      </p>
      <p *ngIf="(customer$ | async)?.enableJobRequestProcess">
        {{ "downloadGuideTextForRequester" | i18n }}
        <br />
        <a href="/assets/static/inpool_anleitung_fuer_besteller_DE.pdf">{{
          "german" | i18n
        }}</a>
      </p>
    </ng-container>
    <ng-container *ngIf="role == roleEnum.REQUESTER">
      <p>
        {{ "downloadGuideTextInformal" | i18n }}
        <br />
        <a href="/assets/static/inpool_anleitung_fuer_besteller_DE.pdf">{{
          "german" | i18n
        }}</a>
      </p>
      <p>
        {{ "supportTextRequester" | i18n }}
      </p>
    </ng-container>
    <ng-container *ngIf="!role && role !== roleEnum.POOL && initialized">
      <p>
        {{ "supportTextNotLoggedIn" | i18n }}
      </p>
      <p>
        {{ "deleteProfileTextNotLoggedIn" | i18n }}
      </p>
      <p>
        {{ "email" | i18n }}:
        <a href="mailto:support@intemp.ch">support@intemp.ch</a>
      </p>
    </ng-container>
  </ng-template>
</div>
